import React, { useCallback } from "react"
import { observer } from "mobx-react"
import styled, { ThemeProvider } from "styled-components"
import ReactModal from "react-modal"
import { Grid, Col, Row } from "react-styled-flexboxgrid"

import useInject from "~/hooks/useInject"
import Spacer from "~/components/Spacer"
import WinItButton from "~/components/WinItButton"
import MODAL_STYLES from "~/components/modals/styles"
import FullName from "../dashboard/Profile/Forms/FullName"
import Email from "../dashboard/Profile/Forms/Email"
import PhoneNumber from "../dashboard/Profile/Forms/PhoneNumber"

const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 550px;
  height: 100%;
  margin: 0 auto;
`

const ModalTitle = styled.div`
  font-family: ${props => props.theme.fonts.avenirNextBold};
  font-size: 1.5em;
`

const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 200px;
`

const FormContainer = () => (
  <ThemeProvider theme={{ flexboxgrid: { outerMargin: 0 }}}>
    <Grid style={{ width: "100%" }}>
      <Row>
        <Col xs={12}>
          <FullName isEditing />
        </Col>
      </Row>

      <Row>
        <Col xs={12}>
          <Email isEditing />
        </Col>
      </Row>

      <Row>
        <Col xs={12}>
          <PhoneNumber isEditing />
        </Col>
      </Row>
    </Grid>
  </ThemeProvider>
)

const mapStore = store => ({
  user: store.auth.user,
  isMobile: store.ui.isMobile,
})

const UserMissingInfo = () => {
  const { user, isMobile } = useInject(mapStore)
  const { isMissingInformation, accountDeleted } = user

  const save = useCallback(async () => {
    const keysToSave = ["name", "username", "email", "phoneNumber"]
    await user.updateUser(keysToSave)
  }, [user])

  return (
    <ReactModal
      closeTimeoutMS={300}
      isOpen={isMissingInformation && !accountDeleted}
      style={
        isMobile ? MODAL_STYLES.mobile.general : MODAL_STYLES.desktop.general
      }
      onRequestClose={() => {}}
    >
      <ModalContainer>
        <ModalTitle>
          We need some important information for your profile
        </ModalTitle>
        <Spacer mobile={16} desktop={16} />
        <FormContainer />
        <Spacer mobile={16} desktop={16} />
        <ButtonContainer>
          <WinItButton
            color="green"
            width="100%"
            height={70}
            fontSize="1rem"
            type="submit"
            onClick={save}
          >
            Save
          </WinItButton>
        </ButtonContainer>
      </ModalContainer>
    </ReactModal>
  )
}

export default observer(UserMissingInfo)
